module.exports = __webpack_public_path__ + "public/images/gaming-background-pattern.e1b9e7dd420bcc01add700d82497bccd.svg";